function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment projectFields on Projects {\n    id\n    name\n    created_at\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment instanceFields on Instances {\n    id\n    api_application_id\n    created_at\n    name\n    service_name\n    ActiveDeployment {\n      created_at\n      Package {\n        ProductVersions {\n          id\n          version\n          Product {\n            name\n          }\n        }\n      }\n    }\n    Region {\n      id\n      name\n      metadata_url\n      deployment_api_url\n      endpoint_url_scheme\n      host_template\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment activeVersionFields on ProductVersions {\n    id\n    version\n    icon\n    status\n    short_description\n    deploy_enabled\n    code_template_enabled\n    long_description @include(if: $withDesc)\n    documentation @include(if: $withDocs)\n    VersionTags {\n      Tag {\n        name\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
import { gql } from "graphql-request";
export var projectFragment = gql(_templateObject());
export var instanceFragment = gql(_templateObject1());
export var activeVersionFragment = gql(_templateObject2());

//# sourceMappingURL=fragments.js.map